import React, { FC, useCallback, useMemo } from 'react';
import { FieldDto } from '@families-link/shared';
import { CellAction, CoreTableActionsCell } from '../../../_core/components/_ui/core-table';
import { DeleteIcon, EditIcon } from '../../../_core/components/icons';
import { useTranslation } from 'react-i18next';

interface CustomRequirementsTableActionsProps {
	field: FieldDto;
	onDelete(field: FieldDto): void;
	onEdit(field: FieldDto): void;
}

export const CustomRequirementsTableActions: FC<CustomRequirementsTableActionsProps> = (props) => {
	const { field, onDelete, onEdit } = props;
	const [t] = useTranslation();

	const handleDeleteCustomField = useCallback(() => {
		if (!field) {
			return;
		}

		onDelete?.(field);
	}, [onDelete, field]);

	const handleEditCustomField = useCallback(() => {
		if (!field) {
			return;
		}
		onEdit?.(field);
	}, [onEdit, field]);

	const isDefault = field.attributeType === 'Default';
	const isOptions = field.dataType === 'Options';

	const actions = useMemo<CellAction[]>(
		() => [
			{
				id: 'edit',
				type: 'button',
				tooltipTitle: t('buttons.tooltips.edit'),
				props: {
					children: <EditIcon sx={{ fontSize: 30 }} color={isDefault && !isOptions ? 'disabled' : 'primary'} />,
					disabled: isDefault && !isOptions,
					onClick: handleEditCustomField,
					variant: 'secondary',
				},
			},
			{
				id: 'delete',
				type: 'button',
				tooltipTitle: t('buttons.tooltips.delete'),
				props: {
					children: <DeleteIcon sx={{ fontSize: 30 }} color={isDefault ? 'disabled' : 'primary'} />,
					disabled: isDefault,
					onClick: handleDeleteCustomField,
					variant: 'secondary',
				},
			},
		],
		[handleEditCustomField, handleDeleteCustomField, isDefault]
	);

	return <CoreTableActionsCell actions={actions} />;
};
